var map = {
	"./arabic.json": 480,
	"./bulgarian.json": 481,
	"./czech.json": 482,
	"./denmark.json": 483,
	"./english.json": 484,
	"./finnish.json": 485,
	"./greek.json": 486,
	"./indonesian.json": 487,
	"./malay.json": 488,
	"./norwegian.json": 489,
	"./romanian.json": 490,
	"./slovakia.json": 491,
	"./swedish.json": 492,
	"./thai.json": 493
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2458;


//////////////////
// WEBPACK FOOTER
// ./src/locales/mobiflix [A-Za-z0-9-_,\s]+\.json$/
// module id = 2458
// module chunks = 0